import { makeAutoObservable } from 'mobx'
import {DrawerStoreInterface} from '../interfaces_and_types'

export class DrawerStore implements DrawerStoreInterface{
    isOpen = false
    currentPage = ''

    changeIsOpen = (bool: boolean) => this.isOpen = bool;

    setCurrentPage = (page: string) => this.currentPage = page;

    constructor() {
        makeAutoObservable(this)
    }
}

const drawerStore = new DrawerStore()
export default drawerStore
